import React from "react"
import { Spinner } from "react-bootstrap"
import { formatDateForDisplay } from "../../utils/dateUtils"

const RepairHistoryView = ({ history = [], loading = false }) => {
  return (
    <div className="repair-history-view h-100 d-flex flex-column">
      <div className="p-3 border-bottom">
        <h6 className="mb-0">
          <i className="fas fa-history me-2" />
          Ιστορικό
        </h6>
      </div>
      <div className="flex-grow-1 overflow-auto">
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" size="sm" className="text-muted" />
            <div className="text-muted mt-2">Φόρτωση ιστορικού...</div>
          </div>
        ) : history.length > 0 ? (
          <div className="history-accordion">
            {history.map(item => (
              <div key={item.ID} className="nav-link mb-2">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <small className="history-meta">{formatDateForDisplay(item.DateTimeStamp)}</small>
                  <small className="history-meta">
                    <i className="fas fa-user me-0" />
                    {item.UserFullname}
                  </small>
                </div>
                <div className="history-update-text">{item.Descr}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-info-circle me-2" />
            Δεν υπάρχει διαθέσιμο ιστορικό
          </div>
        )}
      </div>
    </div>
  )
}

export default RepairHistoryView
